import { render } from "./Parent.vue?vue&type=template&id=631c10a1"
import script from "./Parent.vue?vue&type=script&lang=ts"
export * from "./Parent.vue?vue&type=script&lang=ts"
script.render = render

export default script